import { focusStyle } from '@app/theme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, IconButton, styled } from '@mui/material'

export const ControlWrapper = styled(Box)<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 3),
  ...(isMobile && {
    padding: theme.spacing(2, 5),
  }),
}))

export const ControlsGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}))

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 30,
  height: 30,
  padding: 0,
  borderRadius: 3,
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,

  '&:hover, &:focus, &:focus-visible': {
    backgroundColor: 'var(--bluegrey-100)',
  },

  '&:focus, &:focus-visible': {
    ...focusStyle(theme).border,
  },

  '& svg': {
    fontSize: '0.75rem',
  },
}))

export const ValueDisplay = styled(Button)(({ theme }) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  height: 30,
  minWidth: 55,
  maxWidth: 'max-content',
  background: 'transparent',
  border: `1px solid var(--bluegrey-200)`,
  color: `var(--bluegrey-600)`,
  padding: theme.spacing(2, 3),

  '&:hover, &:focus, &:focus-visible': {
    backgroundColor: 'var(--bluegrey-50)',
  },

  '&:focus, &:focus-visible': {
    ...focusStyle(theme).border,
  },
}))

export const Icon = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.additionalColors['bg_500'],
}))

export const TextWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(4),
}))
